import template from './stVero.template.html';

export default {
  bindings: {
    ticketOwner: '<',
    idTicket: '<',
    contacts: '<',
    onFinished: '<'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, eventService, uiService, veroService, VERO) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;
      ctrl.errors = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        function dialogController(contacts, ticketOwner, idTicket) {
          const self = this;
          self.isCopyOfCoc = false;
          self.contacts = contacts;
          self.ticketOwner = ticketOwner;
          self.idTicket = idTicket;
          self.availableInsuranceTypes = VERO.INSURANCE_TYPES;

          self.selectedClients = [
            {
              id: ctrl.contacts[0].id,
              name: ctrl.contacts[0].getName(),
              phone: ctrl.contacts[0].getPhone(),
              selectedInsuranceTypes: [],
              selectedHour: ''
            }
          ];

          self.isClientSelected = (contact) =>
            self.selectedClients.some((client) => client.id === contact.id);
          self.addSelectedClient = (client) => {
            self.selectedClients.push({
              id: client.id,
              name: client.getName(),
              phone: client.getPhone(),
              selectedInsuranceTypes: [],
              selectedHour: ''
            });
          };
          self.confirm = () => {
            if (self.validateForm()) {
              self.sendForm();
            } else {
              self.showError(ctrl.errors[0]);
            }
          };
          self.sendForm = () => {
            self.isLoading = true;
            uiService.toast({
              text: {
                p1: 'Sending',
                p2: 'form to Vero',
                p3: 'please wait...'
              }
            });
            const { selectedClients, isCopyOfCoc } = self;
            veroService
              .refer({
                idTicket: self.idTicket,
                selectedContacts: selectedClients,
                isCopyOfCoc
              })
              .then((result) => {
                $mdDialog.hide(result);
              })
              .catch(() => {
                $mdDialog.hide();
              });
          };
          self.contactDelete = ($event, $index) => {
            self.selectedClients.splice($index, 1);
          };
          self.validateForm = () => {
            ctrl.errors = [];
            self.selectedClients.forEach((client) => {
              if (!client.name) {
                ctrl.errors.push('Enter Full Name');
              }
              if (!client.phone) {
                ctrl.errors.push('Enter Preferred Phone');
              }
              if (!client.selectedInsuranceTypes || !client.selectedInsuranceTypes.length) {
                ctrl.errors.push('Select Insurance Type');
              }
              if (!client.selectedHour) {
                ctrl.errors.push('Select Preferred Hour');
              }
              if (!self.isCopyOfCoc) {
                ctrl.errors.push('Accept Terms of Use');
              }
            });

            return !ctrl.errors.length;
          };
          self.showError = (missingField) => {
            uiService.toast({
              text: {
                p1: 'Please',
                p2: missingField,
                p3: ``
              },
              warn: true
            });
          };
          self.cancel = () => {
            $mdDialog.hide(false);
          };
        }

        $mdDialog
          .show({
            targetEvent: null,
            locals: {
              contacts: ctrl.contacts,
              ticketOwner: ctrl.ticketOwner,
              idTicket: ctrl.idTicket
            },
            template,
            controllerAs: '$ctrl',
            controller: dialogController
          })
          .then((result) => {
            if (result) {
              uiService.toast({
                text: {
                  p1: 'Form was',
                  p2: result.status ? 'successfully submitted.' : 'not submitted',
                  p3: result.status ? 'Log saved as Note.' : result.message
                },
                success: result.status,
                warn: !result.status
              });
            }

            ctrl.onFinished();
          });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        if (ctrl.destroyWatch) {
          ctrl.destroyWatch();
        }
      };
    }
  }
};
